import { OmniDashboard } from "@swivl-mono/types";

import { ReportSearchEntry, SearchResultCategory } from "./GlobalSearch.Types";

export function buildReportSearchEntries(dashboards: OmniDashboard[]): ReportSearchEntry[] {
  return dashboards.map((dashboard) => ({
    id: `report:${dashboard.id}`,
    category: SearchResultCategory.REPORT,
    title: dashboard.name,
    breadcrumb: dashboard.folder,
    dashboardId: dashboard.id,
    folder: dashboard.folder,
    matchText: dashboard.name.toLowerCase()
  }));
}
